import { render } from "./TicketsDisplayList.vue?vue&type=template&id=5b8a81ff&scoped=true&lang=pug"
import script from "./TicketsDisplayList.vue?vue&type=script&lang=ts"
export * from "./TicketsDisplayList.vue?vue&type=script&lang=ts"

import "./TicketsDisplayList.vue?vue&type=style&index=0&id=5b8a81ff&lang=scss"
import "./TicketsDisplayList.vue?vue&type=style&index=1&id=5b8a81ff&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b8a81ff"

export default script